import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import ja from "vuetify/es5/locale/ja.js";
import VDataFooter from "vuetify/lib/components/VDataIterator/VDataFooter";
import { VDataTable } from "vuetify/lib/components";

//1ページあたりの行数
VDataFooter.options.props.itemsPerPageOptions.default = () => [10, 20, 50, 100, -1];
//VDataTable  noDataText
VDataTable.options.props.noDataText.default = () => "データがありません。";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { ja },
    current: "ja"
  }
});
